export default "__VITE_ASSET__BNVEzhWO__"